import React from 'react'
import { SettingsPage } from '@sales-center/components'
import Stack from '@mui/material/Stack'
import { SettingsHomeSectionTidal } from '@user/components/Settings/Home/SectionTidal'
import { SettingsHomeSubSectionTidal } from '@user/components/Settings/Home/SubSectionTidal'
import { useData } from '@user/components/Settings/Home/hooks/useData'
import { SettingsHomeSubSectionClosingRequirements } from './SubSectionClosingRequirements'

export type SettingHomeProps = {
  campaignTrackingEnabled: boolean
  d2dEnabled: boolean
  mapViewEnabled: boolean
  pendingLeadAutoReviewEnabled: boolean
  serviceCodesEnabled: boolean
}

export function SettingsHomeTidal(props: SettingHomeProps) {
  const { getSettings } = useData(props)

  return (
    <SettingsPage title="Settings Home" padding="40px">
      <Stack
        justifyContent="flex-start"
        alignItems="center"
        sx={{ width: '100%' }} // ⬅️ fill the page width
      >
        {getSettings.map((setting, index) => {
          const { title, subItems } = setting
          return (
            <SettingsHomeSectionTidal title={title} key={index}>
              {subItems.map((settingItem, itemIndex) => {
                const { icon, hide, isClosingRequirement } = settingItem
                return (
                  !hide &&
                  (!isClosingRequirement ? (
                    <SettingsHomeSubSectionTidal
                      {...settingItem}
                      key={itemIndex}
                      icon={icon}
                    />
                  ) : (
                    <SettingsHomeSubSectionClosingRequirements
                      {...settingItem}
                      key={itemIndex}
                      icon={icon}
                    />
                  ))
                )
              })}
            </SettingsHomeSectionTidal>
          )
        })}
      </Stack>
    </SettingsPage>
  )
}
